import _regeneratorRuntime from "/root/code/node_modules/next/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/root/code/node_modules/next/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import { produce } from "immer";
import { mutate } from "swr";
import { HEADER_META_DATA_API } from "../../consts/index";
import { localStorage } from "../localStorage";
export function updateWishlistStateOptimistically() {
  mutate(HEADER_META_DATA_API, /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(currentData) {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", produce(currentData, function (newState) {
                if (newState !== null && newState !== void 0 && newState.data) {
                  var wishlist = JSON.parse(localStorage.getItem("wishlist") || "{}");
                  newState.data.wishlistItemCount = Object.keys(wishlist).filter(function (key) {
                    return key != "null";
                  }).length;
                }
              }));

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }(), false);
}